<script setup>
import {ref, onMounted} from 'vue'
import {useRoute} from 'vue-router'
import {PdfApi} from "@/api/pdf"
import {ProjectApi} from "@/api/project"
import HTTP from "@/api/common"
import LayoutWrapper from "@/views/projects/pdf/contents/LayoutWrapper.vue"
import {notify} from "@kyvg/vue3-notification";

const route = useRoute()

const project = ref(null)
const person = ref(null)
const pdfs = ref([])
const layout_name = ref(null)
const layout = ref(null)
const selectedBlocks = ref([])
const savedData = ref([])

const findElements = (coords) => {
  let data = []
  if (coords) coords.forEach(x => {
    data.push(pdfs.value.find(pdf => pdf.id === x[0]).structure[x[1]][x[2]])
  })
  return data
}

const pxToUnit = (px) => {
  return parseInt(px / 1.333 * 12700)
}

const getLayout = (name) => {

  HTTP.get(`slide_layouts/${layout_name.value}/`).then((response) => {

    PdfApi.get_pdf_layout(route.params.pdf_source, route.params.pdf_date, person.value.id).then(pdf_response => {
      if (response) {
        savedData.value = JSON.parse(JSON.stringify(pdf_response));

      }
      layout.value = JSON.parse(JSON.stringify(response.data))
    })

  })
}

const arrayInArray = (array, element) => {
  return JSON.stringify(array).includes(JSON.stringify(element))
}

const indexArrayInArray = (array, element) => {
  return array.map(x => JSON.stringify(x)).indexOf(JSON.stringify(element))
}

const dragStart = (index, event) => {
  if (!arrayInArray(selectedBlocks.value, index)) {
    selectedBlocks.value = [index]
  }
}

const toggleSelection = (index, event) => {
  if (event.ctrlKey || event.metaKey) {
    const idx = indexArrayInArray(selectedBlocks.value, index)
    if (idx > -1) {
      selectedBlocks.value.splice(idx, 1)
    } else {
      selectedBlocks.value.push(index)
    }
  } else {
    selectedBlocks.value = [index]
  }
}

const clearSelectedBlocks = () =>{
  selectedBlocks.value = []
}

const saveLayouts = (data) => {
  const pdf_data = {
    person: person.value.id,
    date: route.params.pdf_date,
    source: route.params.pdf_source,
    selected: true,
    json: JSON.stringify(data)
  }
  if (savedData.value && savedData.value.id) pdf_data.id = savedData.value.id
  PdfApi.create(pdf_data).then((response) => {
    savedData.value = JSON.parse(JSON.stringify(response));
    notify({
      type: 'success',
      text: 'Сохранено'
    });
  })
}

// Lifecycle hooks
onMounted(() => {
  ProjectApi.get_simple(route.params.id).then(response => {
    project.value = response
  })

  PdfApi.list(route.params.pdf_source, route.params.pdf_date, route.params.id).then(response => {
        const processedPdfs = JSON.parse(JSON.stringify(response));
        processedPdfs.forEach(pdf => {
          person.value = pdf.person
          if (pdf.structure) {
            pdf.structure.forEach(element => {
              element.forEach(cell => {

                if (cell.text) {
                  let paragraphs = cell.text.split("\n");
                  cell.paragraphs = []
                  let sentence_start = 0;
                  paragraphs.forEach((paragraph, i) => {
                    const segmenter = new Intl.Segmenter([], {granularity: "sentence"});
                    const sentences = [...segmenter.segment(paragraph)];
                    let p_sentences = []

                    sentences.forEach((sentence) => {
                      p_sentences.push({
                        text: sentence.segment,
                        start: sentence_start,
                        end: sentence_start + sentence.segment.length + 1
                      });
                      sentence_start += sentence.segment.length + 1;
                    });
                    cell.paragraphs.push(p_sentences)
                    // sentence_start += 1;

                  })


                }
              })
            });
          }
        });
        pdfs.value = processedPdfs

        layout_name.value = pdfs.value[0].get_source_display
        getLayout()
      }
  )
})
</script>

<template>
  <main class="dashboard links">
    <div class="mb-4">
      <h2><b>Проект</b> <span>{{ project?.name }}</span></h2>
      <h6><b>Персона</b> {{ person?.name }} ПФ ID {{ person?.pf_id }}</h6>
      <BackButton></BackButton>
    </div>

    <div class="selection-box" id="selectionBox"></div>

    <div class="screen-list">
      <div class="btn-group" role="group" aria-label="Basic outlined example">
        <router-link
            :to="{name: 'pdf_db_detail', params: {id: $route.params.id, pdf_source: $route.params.pdf_source, pdf_date: $route.params.pdf_date}}"
            type="button" class="btn btn-dark">Структура
        </router-link>
        <router-link
            :to="{name: 'pdf_db_links', params: {id: $route.params.id, pdf_source: $route.params.pdf_source, pdf_date: $route.params.pdf_date}}"
            type="button" class="btn btn-outline-dark">Ссылки
        </router-link>
        <i style="font-size: 9px; max-height: 50px; overflow-y: scroll">
          выделение мышью rect <br>
          Определение layout под комменты и контент <br>

          Добавить объединение ячеек <br>
          ресайз границ таблицы <br>
          Редактирование длинны предложения

          коменнт выезжает за границыик <br>
          ограничение добавления комментариев зоной <br>
          input color opacity off <br>
          иконка для фона <br>
          удление слайдв


        </i>
      </div>

      <div class="wrapper">


        <div class="sources" id="sources">
          <template v-for="pdf in pdfs">
            <h3 class="mt-3 mb-3 border-bottom border-dark">{{ pdf.get_source_display }} <a :href="pdf.pdf"
                                                                                            class="text-primary"
                                                                                            target="_blank">pdf</a></h3>
            <div v-for="(line, l_index) in pdf.structure" class="line">
              <template v-for="(cell, c_index) in line" :key="'source-' + l_index + c_index">
                <div v-if="cell.link || cell.img"
                     :draggable="true"
                     @dragstart="dragStart([pdf.id, l_index, c_index, 0, null], $event)"
                     @click="toggleSelection([pdf.id, l_index, c_index, 0, null], $event)"
                     :class="'cell' + (arrayInArray(selectedBlocks, [pdf.id, l_index, c_index, 0, null])?' selected':'')"
                >
                  <a v-if="cell.link" target="_blank" class="text-primary" :href="cell.link">{{ cell.text }}</a>
                  <img v-else-if="cell.img" :src="cell.img" alt="" style="max-width: 150px">

                </div>
                <template v-else>
                  <div>
                    <p v-for="sentences in cell.paragraphs">
                    <span
                        :draggable="true"
                        @dragstart="dragStart([pdf.id, l_index, c_index, text.start, text.end], $event)"
                        @click="toggleSelection([pdf.id, l_index, c_index, text.start, text.end], $event)"
                        :class="'cell' + (arrayInArray(selectedBlocks, [pdf.id, l_index, c_index, text.start, text.end])?' selected':'')"
                        v-for="text in sentences" :style="cell.style">{{ text.text }}</span>
                    </p>
                  </div>
                </template>
              </template>
            </div>
          </template>
        </div>
        <LayoutWrapper
            :initial-layout="layout"
            :source-type="route.params.pdf_source"
            :selected-blocks="selectedBlocks"
            :find-elements="findElements"
            :saved-data="savedData"
            :clear-selected-blocks="clearSelectedBlocks"
            @save-layouts="saveLayouts"

        />

      </div>


    </div>

  </main>
</template>

<style scoped lang="scss">
.wrapper {
  display: flex;
  gap: 50px;

  .sources {
    max-width: 50%;
    height: 80vh;
    overflow-y: scroll;
    flex: 0 0 auto;

    .line {
      display: flex;
      gap: 10px;
      border-bottom: 1px solid #cecece;
      padding: 5px;

      .cell {
        min-width: 55px;

        a {
          pointer-events: none;
          font-size: 10px;
          line-break: anywhere;
        }

        &:hover {
          cursor: pointer;
          background: #e0e0e0;
        }

        &.selected {
          background: #89d6ff;
        }

      }
    }
  }
}

</style>
